import React, { useEffect } from "react";

import Aos from "aos";
import "aos/dist/aos.css";

import Menu from "../../Components/Menu";

import Section1_Header from "../S1_Header";
import Section2_About from "../S2_Tools";
import S6_Tokenomics from "../S4_Tokenomics";
import Section8_Team from "../S6_Faq";
import Section9_Footer from "../S7_Footer";

import { PageWrapper } from "../../Styles/style";
import styled from "@emotion/styled";

const VideoBG = styled.video`
object-fit: cover;
position: fixed;
width: 100%;
height: 100VH;
`
const Wrapper = styled.div`
position: RELATIVE;
`
const SectionSubWrapper = styled.div`
z-index: 1;
background-size: cover;
background-repeat: no-repeat;
background-position: center;
min-height: 100vh;
`
const MainPage = (props) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <>

      <PageWrapper style={{overflow:"hidden"}}>

          <Menu/>
          <Section1_Header />
          <Section2_About />
          <S6_Tokenomics />
            <Section8_Team />
          <Section9_Footer />
      </PageWrapper>
      
    </>
  );
};

export default MainPage;
